// extracted by mini-css-extract-plugin
export default {"modal":"view-replies-modal_modal__bPTCu","content":"view-replies-modal_content__AJucy"};